import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../theme';
var infoIcon = (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM13 11V17H11V11H13ZM12 20C7.58999 20 3.99999 16.41 3.99999 12C3.99999 7.59 7.58999 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM13 7V9H11V7H13Z", fill: "#9A9A9A" })));
var Hint = function (_a) {
    var className = _a.className;
    var css = useTheme('Checkin').Hint;
    var t = useTranslation('Checkin').t;
    return (React.createElement("div", { className: cn(css.container, className) },
        React.createElement("h2", { className: css.title }, t('How to find a booking?')),
        React.createElement("div", { className: css.info },
            React.createElement("span", { className: css.info__icon }, infoIcon),
            React.createElement("p", { className: css.info__text }, t('Enter the passenger last name (in latin characters) and the booking code. \nYou can find it in the itinerary receipt sent to your email after booking.'))),
        React.createElement("div", { className: css.image })));
};
export default Hint;
